export enum booleanToTextValues {
  DeactivateActive,
  ResolveUnresolve,
}
